import { TApiTaskDetails } from "../../api-client/types"

export function isTaskAboveEstimate(task: TApiTaskDetails) {
  return  !!(task.timeEstimateDuration && task.timeEstimateDuration != 0 && task.worktime && task.timeEstimateDuration < task.worktime)
}